// extracted by mini-css-extract-plugin
export default {"close-icon":"vs6kE5KBAYdwwst","file-delete-button":"NpVnP7w7kPesek5"};